import React, { useState } from 'react';
import Button from '../../../../../muiComponents/Button';
import SendRequestPanel from './SendRequestPanel';
import useTranslate from '../../../../../customHooks/useTranslate';

const RequestsListSendRequest = () => {
    const translate = useTranslate();
    const [isVisiblePanel, setIsVisiblePanel] = useState(false);
    return (
        <>
            <Button
                variant='contained'
                startIcon='Link'
                onClick={() => setIsVisiblePanel(true)}
            >
                {translate('send_new_request')}
            </Button>
            <SendRequestPanel
                open={isVisiblePanel}
                onClose={() => setIsVisiblePanel(false)}
            />
        </>
    );
};

export default RequestsListSendRequest;
